export const SWF_TYPE = {
  SINGLE: 'SINGLE',
  MULTISHOP: 'MULTISHOP'
};

export const SWF_ORDER_OPTIONS = ['ReserveNowPayOnSpot'];
